/*
 * @Author: your name
 * @Date: 2021-12-07 10:21:56
 * @LastEditTime: 2021-12-10 17:37:41
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /homeweb/src/views/Home/_Home.js
 */
// @vue/component
export default {
    name: 'Home',

    components: {},

    mixins: [],

    props: {},

    data () {
        return {}
    },

    computed: {},

    watch: {},

    created () {},

    methods: {}
}
